import { Logout as LogoutIcon } from "@mui/icons-material";
import { Box, Button, Container, Paper } from "@mui/material";
import React from "react";
import { signOutUser } from "../../services/firebase";

interface OnboardingLayoutProps {
  children: React.ReactNode;
}

export const OnboardingLayout: React.FC<OnboardingLayoutProps> = ({ children }) => {
  const handleLogout = async () => {
    try {
      await signOutUser();
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        backgroundColor: "background.default",
        overflow: "auto",
        overflowY: "scroll",
        WebkitOverflowScrolling: "touch",
      }}
    >
      <Container maxWidth="md" sx={{ py: 3 }}>
        <Paper
          elevation={1}
          sx={{
            p: 4,
            borderRadius: 2,
            backgroundColor: "background.paper",
            width: "100%",
            minHeight: "calc(100vh - 48px)", // Ensure content is tall enough to scroll
            position: "relative",
          }}
        >
          {/* Logout button in top-right corner */}
          <Box
            sx={{
              position: "absolute",
              top: 16,
              right: 16,
              zIndex: 1,
            }}
          >
            <Button
              variant="outlined"
              size="small"
              startIcon={<LogoutIcon />}
              onClick={handleLogout}
              sx={{
                color: "text.secondary",
                borderColor: "divider",
                "&:hover": {
                  borderColor: "primary.main",
                  color: "primary.main",
                },
              }}
            >
              Logout
            </Button>
          </Box>

          {children}
        </Paper>
      </Container>
    </Box>
  );
};
